import React from "react";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { actionButtonStyle, declineActionBtn } from "../styles/styles";
import CustomTypography from "../../../Components/Typography";
import { useTranslation } from "react-i18next";

const ModalActionButtons = (props) => {
  const {
    viewType,
    inviteBlockedReason,
    handleInviteClick,
    handleAcceptOffer,
    handleUpdateSupplier,
    handleDeclineOfferModal,
    handleConfirmModal,
    handleRemoveSupplierModal,
    selectedPricelists,
    pricelists,
    supplier,
  } = props;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isCustomScreen = useMediaQuery(theme.breakpoints.down("450"));
  const { t } = useTranslation("modal-action-buttons");

  const offeredCount = pricelists.filter((p) => p.is_offered).length;
  const selectedCount = selectedPricelists.length;

  return (
    <>
      {viewType === "invite" && !inviteBlockedReason && (
        <Button
          variant="contained"
          sx={actionButtonStyle}
          onClick={handleInviteClick}
        >
          {t("buttons.invite")}
        </Button>
      )}
      {viewType === "invite" && inviteBlockedReason && (
        <Box display="flex" flexDirection="column" alignItems="center" gap="8px">
          <CustomTypography
            props={{
              color: "#2F2B3DB2",
              fontWeight: 400,
              fontSize: "13px",
              lineHeight: "18px",
              textAlign: "center",
            }}
          >
            {t(`invite_blocked.${inviteBlockedReason}`)}
          </CustomTypography>
          <Button variant="contained" sx={actionButtonStyle} disabled>
            {t("buttons.invite")}
          </Button>
        </Box>
      )}

      {viewType === "cancel" && (
        <Button
          variant="contained"
          sx={declineActionBtn}
          onClick={() => handleConfirmModal(supplier, "cancel")}
        >
          {t("buttons.cancel_invite")}
        </Button>
      )}

      {viewType === "offer" && (
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {isSmallScreen && (
            <CustomTypography
              props={{
                color: "#2F2B3DB2",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "28px",
              }}
            >
              {selectedCount}/{offeredCount} {t("buttons.pricelists_selected")}
            </CustomTypography>
          )}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            gap="8px"
            width="100%"
          >
            <Button
              variant="contained"
              sx={{
                ...declineActionBtn,
                width: isCustomScreen ? "100%" : "auto",
              }}
              onClick={handleDeclineOfferModal}
            >
              {t("buttons.decline")}
            </Button>

            <Box
              display="flex"
              alignItems="center"
              gap="16px"
              width={isCustomScreen ? "100%" : "auto"}
            >
              {!isSmallScreen && (
                <CustomTypography
                  props={{
                    color: "#2F2B3DB2",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "28px",
                  }}
                >
                  {selectedCount}/{offeredCount}{" "}
                  {t("buttons.pricelists_selected")}
                </CustomTypography>
              )}

              <Button
                variant="contained"
                sx={{
                  ...actionButtonStyle,
                  width: isCustomScreen ? "100%" : "auto",
                }}
                disabled={selectedCount === 0}
                onClick={handleAcceptOffer}
              >
                {t("buttons.accept_selected")}
              </Button>
            </Box>
          </Box>
        </Box>
      )}

      {viewType === "view" && (
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {isSmallScreen && (
            <CustomTypography
              props={{
                color: "#2F2B3DB2",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "28px",
              }}
            >
              {selectedCount}/{offeredCount} {t("buttons.pricelists_selected")}
            </CustomTypography>
          )}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            gap="8px"
            width="100%"
          >
            <Button
              variant="contained"
              sx={{
                ...declineActionBtn,
                width: isCustomScreen ? "100%" : "auto",
              }}
              onClick={handleRemoveSupplierModal}
            >
              {t("buttons.remove_supplier")}
            </Button>

            <Box
              display="flex"
              alignItems="center"
              gap="16px"
              width={isCustomScreen ? "100%" : "auto"}
            >
              {!isSmallScreen && (
                <CustomTypography
                  props={{
                    color: "#2F2B3DB2",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "28px",
                  }}
                >
                  {selectedCount}/{offeredCount}{" "}
                  {t("buttons.pricelists_selected")}
                </CustomTypography>
              )}

              <Button
                variant="contained"
                sx={{
                  ...actionButtonStyle,
                  width: isCustomScreen ? "100%" : "auto",
                }}
                disabled={selectedCount === 0}
                onClick={handleUpdateSupplier}
              >
                {t("buttons.save_changes")}
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ModalActionButtons;
